import { Navigate } from 'react-router-dom';
import { PageLoader } from '@/components/ui';
import { useEnabledModules } from '@/hooks/useEnabledModules';

interface ModuleRouteProps {
  /** Module key this route belongs to (e.g. ModuleKeys.Shop). */
  module: string;
  children: React.ReactNode;
}

/**
 * Guards a tenant-admin route behind an enabled module. If the tenant doesn't
 * have the module (so the backend would 403), redirect home instead of showing
 * a dead page. SuperAdmin and lookup errors pass through (handled by
 * `useEnabledModules`). Shows a loader until the module list is known so we
 * never false-redirect during the first fetch.
 */
export function ModuleRoute({ module, children }: ModuleRouteProps) {
  const { isManageable, ready } = useEnabledModules();

  if (!ready) return <PageLoader />;
  if (!isManageable(module)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default ModuleRoute;
